let env = {};

env.baseURL = 'https://api.tsa.ares-saude.com.br/api/v1/';
env.normalURL = 'https://api.tsa.ares-saude.com.br/';
//env.mode = 'homolog';
//env.mode = 'contingencia';
env.mode = 'production';
//env.mode = 'development';

export default env